import { atom } from 'jotai';
import { CpOrderInvoicesDetailsPageState } from './cp_order_invoices_details_types';
import {
    cpOrderInvoicesDetailsModelVM,
    cpOrderInvoicesDetailsPageStateVM,
} from './cp_order_invoices_details_view_models';
import { CpOrderInvoicesDataItem } from '../list/cp_order_invoices_list_types';
import { TblView, TblStats, TableFilters, TableState } from '../../../core/table/table.types';
import { tableViewVM, tableStatsVM, tableStateVM } from '../../../core/table/table_view_models';

export const cpOrderInvoicesDetailsPageStateAtom = atom<CpOrderInvoicesDetailsPageState>(
    cpOrderInvoicesDetailsPageStateVM(),
);
export const cpOrderInvoicesDetailsModelAtom = atom<CpOrderInvoicesDataItem>(cpOrderInvoicesDetailsModelVM());

export const cpOrderInvoiceDetailsTableStateAtom = atom<TableState>(tableStateVM());
export const cpOrderInvoiceDetailsTableViewAtom = atom<TblView>(tableViewVM());
export const cpOrderInvoiceDetailsTableStatsAtom = atom<TblStats>(tableStatsVM());
export const cpOrderInvoiceDetailsTableFiltersAtom = atom<TableFilters>({});

// Reconcile Feature
export const invoiceLineItemPageReconcileAtom = atom<boolean>(false);
export const invoiceLineItemPageReconcileIdsAtom = atom<string[]>([]);
export const invoiceLineItemPageReconcileIdAtom = atom<string | undefined>(undefined);
